import { Directive, ElementRef, AfterViewInit, Input } from '@angular/core';

@Directive({
    selector: '[appDragTabs]',
    standalone: false
})
export class DragTabsDirective implements AfterViewInit {
  @Input() useDragging = false;
  private isDragging = false;
  private startX: number;
  private scrollLeft: number;
  private container: HTMLElement;

  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    this.container = this.el.nativeElement.querySelector('.mat-mdc-tab-header') as HTMLElement;
    // Add 'passive' to make the page more responsive 
    this.container.addEventListener('mousedown', this.startDragging.bind(this), { passive: true });
    this.container.addEventListener('touchstart', this.startDragging.bind(this), { passive: true });
    this.container.addEventListener('mouseup', this.stopDragging.bind(this), { passive: true });
    this.container.addEventListener('mouseleave', this.stopDragging.bind(this), { passive: true });
    this.container.addEventListener('touchend', this.stopDragging.bind(this), { passive: true });
    this.container.addEventListener('touchcancel', this.stopDragging.bind(this), { passive: true });
    this.container.addEventListener('mousemove', this.moveEvent.bind(this), { passive: true });
    this.container.addEventListener('touchmove', this.moveEvent.bind(this), { passive: true });
  }

  getClientX(event: MouseEvent | TouchEvent): number {
    if (event instanceof MouseEvent) {
      return event.clientX;
    } else if (event instanceof TouchEvent) {
      return event.touches[0].clientX;
    }
    return 0;
  }

  // to drag the scrollbar
  startDragging(event: MouseEvent | TouchEvent) {
    if (this.useDragging) {
      this.isDragging = true;
      const clientX = this.getClientX(event);
      this.startX = clientX - this.container.offsetLeft;
      this.scrollLeft = this.container.scrollLeft;
    }
  }

  stopDragging() {
    this.isDragging = false;
  }

  moveEvent(event: MouseEvent | TouchEvent) {
    if (this.isDragging) {
      const clientX = this.getClientX(event);
      const x = clientX - this.container.offsetLeft;
      const scroll = x - this.startX;
      this.container.scrollLeft = this.scrollLeft - scroll;
    }
  }
}
